import { render, staticRenderFns } from "./VinculationForm.vue?vue&type=template&id=1fa9639c"
import script from "./VinculationForm.vue?vue&type=script&lang=js"
export * from "./VinculationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports